// Aceite público de convite (staff e médico). O convidado abre o link do e-mail,
// vê os dados do convite e completa o cadastro (CPF/telefone/senha) — sem auth.
// O médico também informa os dados profissionais (conselho, registro, UF,
// especialidade, RQE — só CRM — e bio). Quem já tem conta na Videomedi
// (`existing_account` no show) confirma só a senha dela.
import AXIOS from "@/services/axios";

export class ClinicInvite {
  static show(kind, token) {
    return AXIOS.get(`${basePath(kind)}/${token}`);
  }

  static accept(kind, token, payload, { existingAccount = false } = {}) {
    if (existingAccount) {
      return AXIOS.post(`${basePath(kind)}/${token}/accept`, {
        password: payload.password
      });
    }
    const body = {
      cpf: payload.cpf,
      phone_number: payload.phoneNumber,
      birthday: payload.birthday,
      password: payload.password,
      password_confirmation: payload.passwordConfirmation
    };
    if (kind === "doctor") {
      body.council_id = payload.councilId;
      body.council_number = payload.councilNumber;
      body.council_uf = payload.councilUf;
      body.specialty = payload.specialty;
      body.rqe = payload.rqe;
      body.short_bio = payload.shortBio;
    }
    return AXIOS.post(`${basePath(kind)}/${token}/accept`, body);
  }
}

// staff → /clinica/invitations ; médico → /clinica/doctor_invitations
function basePath(kind) {
  return kind === "doctor"
    ? "clinica/doctor_invitations"
    : "clinica/invitations";
}

export default ClinicInvite;
